import styled from '@emotion/styled'
import React, { useEffect } from 'react'
import Image from 'next/image'
import fitty from 'fitty'
import { Sex } from '@/firebase/firestore/Sex'

type Props = {
  targetId: string
  templateColor: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7
  uid: string
  name: string
  sex: Sex
  platform: Array<0 | 1 | 2 | 3 | 4>
  voiceChat: Array<0 | 1 | 2 | 3 | 4 | 5 | 99>
  voiceChatFree: string
  playStyle: string
  fontFamily: string
  fontColor: string
  playTimeWeekDayBegin: string
  playTimeWeekDayEnd: string
  playTimeWeekEndBegin: string
  playTimeWeekEndEnd: string
  hitokoto: string
}

export const Fallguys1: React.FC<Props> = ({
  targetId,
  templateColor,
  fontFamily,
  fontColor,
  uid,
  name,
  sex,
  playStyle,
  platform,
  voiceChat,
  voiceChatFree,
  playTimeWeekDayBegin,
  playTimeWeekDayEnd,
  playTimeWeekEndBegin,
  playTimeWeekEndEnd,
  hitokoto,
}) => {
  useEffect(() => {
    fitty('#name', {
      maxSize: 28,
      minSize: 8,
    })
    fitty('#uid', {
      maxSize: 28,
      minSize: 8,
    })
    fitty('#playStyle', {
      maxSize: 21,
      minSize: 12,
    })
    fitty('#voiceChatFree', {
      maxSize: 21,
      minSize: 8,
    })
    fitty('#hitokoto', {
      maxSize: 18,
      minSize: 14,
    })
  }, [])
  return (
    <Container id={targetId} fontFamily={fontFamily} fontColor={fontColor}>
      {
        <Image
          width="1754"
          height="1240"
          priority={true}
          unoptimized={true}
          alt="フォールガイズ自己紹介カード"
          src={`/static/images/profiles/fallguys1/${templateColor}.jpeg`}
        />
      }
      <Name>
        <span id="name">{name}</span>
      </Name>
      <Id>
        <span id="uid">{uid}</span>
      </Id>
      <PlayTimeWeekDay>
        平日 {playTimeWeekDayBegin}〜{playTimeWeekDayEnd}時
      </PlayTimeWeekDay>
      <PlayTimeWeekEnd>
        休日 {playTimeWeekEndBegin}〜{playTimeWeekEndEnd}時
      </PlayTimeWeekEnd>
      <Hitokoto>
        <span id="hitokoto">{hitokoto}</span>
      </Hitokoto>
      <SexDiv>
        {sex === 0 && '♂'}
        {sex === 1 && '♀'}
      </SexDiv>
      {playStyle === 'beginner' && <PlayStyle0 />}
      {playStyle === 'enjoy' && <PlayStyle1 />}
      {playStyle === 'serious' && <PlayStyle2 />}
      {platform.includes(1) && <Device0 />}
      {platform.includes(0) && <Device1 />}
      {platform.includes(3) && <Device2 />}
      {platform.includes(2) && <Device3 />}
      {voiceChat.includes(0) && <VCSkype />}
      {voiceChat.includes(1) && <VCLine />}
      {voiceChat.includes(3) && <VCDiscord />}
      {voiceChat.includes(4) && <VCKikisen />}
      {voiceChat.includes(5) && <VCSwitch />}
      {voiceChat.includes(99) && <VC99 />}
      <VoiceChatOther>
        <span id={'voiceChatFree'}>{voiceChatFree}</span>
      </VoiceChatOther>
    </Container>
  )
}

const Container = styled.div<{ fontFamily: string; fontColor: string }>`
  position: relative;
  width: 100%;
  line-height: 0;
  * {
    line-height: 1;
    font-family: ${({ fontFamily }) => fontFamily};
    color: ${({ fontColor }) => fontColor};
    border-color: ${({ fontColor }) => fontColor};
  }
`

const Name = styled.span`
  position: absolute;
  top: 21%;
  left: 20%;
  width: 30%;
  height: 11%;
  word-break: break-all;
  align-items: center;
  display: flex;

  span {
    text-align: center;
    font-weight: bold;
    justify-content: center;
  }
`

const Id = styled.span`
  position: absolute;
  top: 21%;
  left: 58%;
  width: 30%;
  height: 11%;
  word-break: break-all;
  align-items: center;
  display: flex;

  span {
    text-align: center;
    font-weight: bold;
    justify-content: center;
  }
`

const SexDiv = styled.div`
  position: absolute;
  top: 22%;
  left: 44%;
  font-size: 30px;
  font-weight: bold;
`

const PlayTimeWeekDay = styled.span`
  position: absolute;
  top: 86%;
  left: 6%;
  font-size: 12px;
  font-weight: bold;
`

const PlayTimeWeekEnd = styled.span`
  position: absolute;
  top: 86%;
  left: 30%;
  color: #fd8080;
  font-size: 12px;
  font-weight: bold;
`

const PlayStyleBase = styled.div`
  position: absolute;
  top: 43.5%;
  left: 9.5%;
  border: solid 2px;
  width: 38px;
  height: 20px;
  border-radius: 10px;
`

const PlayStyle0 = styled(PlayStyleBase)``

const PlayStyle1 = styled(PlayStyleBase)`
  left: 21%;
  width: 58px;
  height: 20px;
  border-radius: 10px;
`

const PlayStyle2 = styled(PlayStyleBase)`
  left: 38%;
  width: 28px;
  height: 20px;
`

const Device0 = styled.div`
  position: absolute;
  top: 43.5%;
  left: 55.5%;
  border: solid 3px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
`
const Device1 = styled(Device0)`
  left: 65%;
`
const Device2 = styled(Device0)`
  left: 74%;
`
const Device3 = styled(Device0)`
  left: 83.5%;
`

const VCBase = styled.div`
  position: absolute;
  top: 62.5%;
  left: 4%;
  border: solid 4px;
  border-radius: 50%;
  width: 34px;
  height: 34px;
`

const VCDiscord = styled(VCBase)``

const VCLine = styled(VCBase)`
  left: 13.5%;
`

const VCSkype = styled(VCBase)`
  left: 23%;
`

const VCKikisen = styled(VCBase)`
  top: 60%;
  border-radius: 50px;
  width: 29%;
  height: 7%;
  left: 59%;
`

const VCSwitch = styled(VCBase)`
  left: 57.5%;
`

const VC99 = styled(VCBase)`
  top: 51%;
  left: 88.5%;
`

const VoiceChatOther = styled.span`
  position: absolute;
  top: 68.5%;
  left: 34.5%;
  width: 16%;
  text-align: center;
  font-weight: bold;
  word-break: break-all;
  line-height: 13px;
`

const Hitokoto = styled.div`
  position: absolute;
  top: 66%;
  left: 55%;
  width: 38%;
  height: 30%;
  word-break: break-all;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-weight: bold;
    line-height: 1.4;
  }
`
